import { EDashboardWidgetTypes, type IDashboardWidgetProps } from '@sharedInterfaces/IDashboard';
import { BoxButton } from '@src/App/Components/Buttons/BoxButton/BoxButton';
import LinkInput from '@src/App/Components/General/FormularElements/formsControls/inputs/LinkInput/LinkInput';
import TextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/TextInput/TextInput';
import type { TWidgetDefinition } from '@src/App/Pages/DashboardPage/Dashboard/Dashboard';
import React from 'react';

import styles from './ButtonBoxDashboardWidget.module.css';

const ButtonBoxDashboardWidget: React.FC<IDashboardWidgetProps<EDashboardWidgetTypes.buttonBoxWidget>> = ({
    id,
    params,
    isEditing,
    onParamChange,
}) => {
    if (isEditing)
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <TextInput
                    name="displayName"
                    placeholder="Anzeigetext"
                    value={params.title}
                    onChange={(value) => onParamChange(id, 'title', value)}
                />
                <TextInput
                    name="description"
                    placeholder="Beschreibung"
                    value={params.description}
                    onChange={(value) => onParamChange(id, 'description', value)}
                />
                <LinkInput
                    placeholder="Link"
                    value={params.link}
                    onChange={(value) => onParamChange(id, 'link', value)}
                />
            </div>
        );
    else
        return (
            <BoxButton
                key={id}
                className={styles.buttonBoxWidget}
                title={params.title}
                description={params.description}
                onClick={params.link}
            />
        );
};

export const buttonBoxDashboardWidgetDefinition = {
    type: EDashboardWidgetTypes.buttonBoxWidget,
    render: ButtonBoxDashboardWidget,
    overrideCardDesign: true,
    defaultParams: { title: 'PROTOS', description: 'PROTOS Homepage', link: 'https://www.protos-technologie.de/' },
} satisfies TWidgetDefinition;
